// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Yh-z","play":"Zh-z"};